import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/hooks/useAuth'
import { getAlertReview, getAlertReviews, saveAlertReview, type AlertReviewFilters } from '@/lib/alertReviews'

export function useAlertReviews(filters: AlertReviewFilters) {
  const { user } = useAuth()
  return useQuery({
    queryKey: ['alert-reviews', user?.username, filters],
    queryFn: () => getAlertReviews(filters),
    enabled: !!user?.username,
    refetchInterval: 30000,
  })
}

export function useAlertReview(id: string) {
  const { user } = useAuth()
  return useQuery({
    queryKey: ['alert-reviews', user?.username, 'detail', id],
    queryFn: () => getAlertReview(id),
    enabled: !!user?.username && !!id,
    retry: false,
  })
}

export function useSaveAlertReview() {
  const client = useQueryClient()
  const { user } = useAuth()
  return useMutation({
    mutationFn: ({ id, note, acknowledged }: { id: string; note: string; acknowledged: boolean }) => saveAlertReview(id, note, acknowledged),
    onSuccess: () => client.invalidateQueries({ queryKey: ['alert-reviews', user?.username] }),
  })
}
